import type { IInstallationPoint } from '@model/installationPoint';

export const getInstPointInfo = (
  point: IInstallationPoint,
  equipmentType: string,
  t: (text: string) => string,
) => {
  if (equipmentType === 'node') {
    return t('Waites System Node');
  }

  if (equipmentType === 'gateway') {
    return t('Waites System Gateway');
  }

  if (equipmentType === 'router') {
    return t('Waites System Repeater');
  }

  return point?.name;
};
